<template>
  <div class="filter">
    <div class="filter_form">
      <div class="level bottom">
        <div class="level-left">
          <b-field class="input_checkbox">
            <b-checkbox @input="$emit('handle-change')" v-model="search.trashed" type="is-info">
              Показать архивные
            </b-checkbox>
          </b-field>
        </div>
        <div class="level-right filter_actions">
          <button
            class="delete_course"
            @click="$emit('delete-checked')"
            v-if="!search.trashed"
            :disabled="!rows.checked.length"
          >
            <i class="mdi mdi-account-remove-outline"></i> В архив
          </button>
          <button class="delete_course" @click="$emit('restore')" v-else :disabled="!rows.checked.length">
            <i class="mdi mdi-account-check-outline"></i> Восстановить
          </button>
          <button class="add_course button_line" @click="$emit('open-modal')">
            <i class="mdi mdi-account-plus-outline"></i> Добавить пользователей
          </button>
          <button class="add_course " @click="$emit('open-file-modal')">
            <i class="mdi mdi-account-plus-outline"></i>Добавить с помощью Excel 
          </button>
        </div>
      </div>
      <form class="level" @submit.prevent="$emit('handle-change')">
        <b-field label="Поиск по роли:" type="is-info" class="role_select">
          <b-select placeholder="Роль" v-model="search.role">
            <option :value="0">Роль</option>
            <option :value="1">Администратор</option>
            <option :value="2">Студент</option>
            <option :value="3">Методист</option>
            <option :value="4">Руководитель</option>
            <option :value="5">Системный администратор</option>
          </b-select>
        </b-field>
        <b-field label="Поиск по филиалу:" type="is-info" class="branch_select">
          <b-select v-model="search.branch_id" placeholder="Филиал">
            <option :value="0">Филиал</option>
            <option v-for="(branch, i) in branchesList" :key="i" :value="branch.id">{{ branch.name }}</option>
          </b-select>
        </b-field>
        <b-field label="Поиск по ФИО:" class="input_search with_button" type="is-info">
          <b-input placeholder="Поиск пользователей" v-model="search.name"></b-input>
          <button class="down_button" type="submit">Поиск</button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    rows: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    branchesList() {
      return this.$store.state.right.rightBranchesList
    }
  }
}
</script>
